/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Nom, NomInterface } from "../Nom";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IFeeModule",
        name: "_feeModule",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousFeeModule",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newFeeModule",
        type: "address",
      },
    ],
    name: "FeeModuleChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "NameOwnerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "previousResolution",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newResolution",
        type: "address",
      },
    ],
    name: "NameResolutionChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "expirations",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "feeModule",
    outputs: [
      {
        internalType: "contract IFeeModule",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "durationToReserve",
        type: "uint256",
      },
    ],
    name: "reserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "durationToExtend",
        type: "uint256",
      },
    ],
    name: "extend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "resolve",
    outputs: [
      {
        internalType: "address",
        name: "resolution",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "newResolution",
        type: "address",
      },
    ],
    name: "changeResolution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "nameOwner",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "changeNameOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IFeeModule",
        name: "newFeeModule",
        type: "address",
      },
    ],
    name: "setFeeModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "isExpired",
    outputs: [
      {
        internalType: "bool",
        name: "expired",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
];

const _bytecode =
  "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";

type NomConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NomConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Nom__factory extends ContractFactory {
  constructor(...args: NomConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _feeModule: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Nom> {
    return super.deploy(_feeModule, overrides || {}) as Promise<Nom>;
  }
  getDeployTransaction(
    _feeModule: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_feeModule, overrides || {});
  }
  attach(address: string): Nom {
    return super.attach(address) as Nom;
  }
  connect(signer: Signer): Nom__factory {
    return super.connect(signer) as Nom__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NomInterface {
    return new utils.Interface(_abi) as NomInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Nom {
    return new Contract(address, _abi, signerOrProvider) as Nom;
  }
}
